import React, {useEffect, useState} from 'react';
import styles from './App.module.scss';
import ListWithRedactor from "./components/ListWithRedactor/ListWithRedactor";
import Authorization from "./components/Authorization/Authorization";

export type GetUserDataResult = {
	email: string;
	exp: number;
	iat: number;
	id: number;
	name: string;
	roleId: number;
	surname: string;
}
export type TextResponse = {
	message: string;
}
function App() {
    const [id, setId] = useState<number>(0)
    const [name, setName] = useState<string>("")
    const [email, setEmail] = useState<string>("")
    const [surname, setSurname] = useState<string>("")
    const [roleId, setRoleId] = useState<number>(0)
    const [token, setToken] = useState<string>("")
    const [authState, setAuthState] = useState<boolean|null>(null)
    const checkToken = ()=>{
        let token = localStorage.getItem("token")
        if (token==null) {
            setAuthState(false)
        } else {
            fetch(process.env.REACT_APP_BASE_URL+"/GetUserData",{
                headers:{
                    "Authorization":token
                }
            }).then(async (response)=> {
                return {
                    status:response.status,
                    data: await response.json()
                }
            }).then((result)=>{
                if(result.status===200){
                    setId((result.data as GetUserDataResult).id)
                    setName((result.data as GetUserDataResult).name)
                    setSurname((result.data as GetUserDataResult).surname)
                    setEmail((result.data as GetUserDataResult).email)
                    setRoleId((result.data as GetUserDataResult).roleId)
                    setToken(token as string)
                    setAuthState(true)
                } else {
                    setAuthState(false)
                    console.log((result.data as TextResponse).message)
                }
            }).catch((e)=>{
                console.log(e)
            })
        }
    }
    const exit = ()=>{
        localStorage.removeItem("token")
        setAuthState(false)
    }
    useEffect(() => {
        checkToken()
    }, []);
    return (
        <div className={styles.App}>
            <div className={styles.Header}>
                {authState === true ? <div className={styles.Name} >{name+" "+surname}</div>:null}
                {authState === true ? <button onClick={exit} className={styles.ExitButton}>Выйти</button>:null}
            </div>
            <div className={styles.Container}>
                {(() => {
                    switch (authState) {
                        case true:
                            return <ListWithRedactor setAuthState={setAuthState} token={token}/>
                        case false:
                            return <Authorization  setAuthState={setAuthState}
                                                   setEmail={setEmail}
                                                   setId={setId}
                                                   setName={setName}
                                                   setRoleId={setRoleId}
                                                   setSurname={setSurname}
                                                   setToken={setToken}
                            />
                        case null:
                            return <div className={styles.Preloader}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 150">
                                    <path fill="none" stroke="#FF156D" stroke-width="16" stroke-linecap="round"
                                          stroke-dasharray="300 385" stroke-dashoffset="0"
                                          d="M275 75c0 31-27 50-50 50-58 0-92-100-150-100-28 0-50 22-50 50s23 50 50 50c58 0 92-100 150-100 24 0 50 19 50 50Z">
                                        <animate attributeName="stroke-dashoffset" calcMode="spline" dur="2"
                                                 values="685;-685" keySplines="0 0 1 1"
                                                 repeatCount="indefinite"></animate>
                                    </path>
                                </svg>
                            </div>
                    }
                })()}
            </div>
        </div>
    );
}

export default App;
